import { render, staticRenderFns } from "./ConsultaPrevia.vue?vue&type=template&id=5645fcc7"
import script from "./ConsultaPrevia.vue?vue&type=script&lang=js"
export * from "./ConsultaPrevia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports